import {
  filterTenantUsersForList,
  selectTenantUserOptions,
  sortTenantUsersByName,
  tenantUserDisplayTitle
} from '../model/tenant-user-selectors'

/**
 * Exposes the pure tenant-user list/select selectors to the component layer.
 * Components and views must not value-import `model/` directly (the MVVM
 * internal-import rule); this composable is the blessed indirection.
 */
export function useTenantUserSelectors() {
  return {
    filterTenantUsersForList,
    selectTenantUserOptions,
    sortTenantUsersByName,
    tenantUserDisplayTitle
  }
}
